<template>
    <div>
        <div>
            <x-grid
                    :id="'formList'"
                    :rowId="rowId"
                    :pager-config="pagerConfig"
                    :form-config="formConfig"
                    :url="url"
                    :columns="columns"
                    :checkbox-config="checkboxConfig"
                    :toolbar-config="toolbarConfig"
                    :print-config="printConfig"
                    :export-config="exportConfig"
                    :import-config="importConfig"
                    ref="grid"
                    :cellClick="chooseRow"
                    :cellDbClick="updateRow"
                    @toolbar-addData="addRow"
                    @toolbar-delData="delRow"
            >
                <template v-slot:[toolbarConfig.templatelSlots]>
                    <vxe-button @click="download">下载模板</vxe-button>
                    <a-upload
                            name="file"
                            :multiple="false"
                            :accept="'.xlsx'"
                            :action="api.visit.UPLOAD"
                            :headers="{token:token}"
                            :showUploadList="false"
                            @change="handleFileChange"
                            style="margin: 0 0 0 3px"
                    >
                        <vxe-button>导入</vxe-button>
                    </a-upload>
                </template>

                <template v-slot:operate="{row}">
                    <vxe-button style="margin-right: 10px" size="mini" status="primary" @click="updateRow({row})">修改</vxe-button>
                    <vxe-button style="margin-right: 10px" size="mini" @click="deleteGroup(row)">删除</vxe-button>
                </template>
            </x-grid>

            <!--明细页表单简化通用写法-->
            <formModal title="新增拜访计划" :visible="editModalVisible">
                <detailForm :rowId="editRowId"
                            v-if="editModalVisible"
                            ref="detailForm"
                            @cancelled="closeEdit()"
                            @saved="closeEdit(true)">
                </detailForm>
            </formModal>

        </div>
    </div>
</template>

<script>
    import XGrid from "@/components/grid/XGrid";
    import {GridMixin} from "@/utils/GridMixin";
    import api from "@/services/api";
    //新增的
    // import {XEUtils} from "@/utils/common/FormBase";
    //弹出层组件
    import {mapMutations, mapState} from "vuex";
    import {dataApi} from '@/services/visit/plan';
    import detailForm from "./add";
    import axios from 'axios';

    const fac = XGrid.factory;

    //列表接口
    const url = api.visit.PLAN;

    //主键
    const rowId = "id";

    //列
    const columns = [
        fac.makeColumnCheckboxDefault(),
        fac.makeColumnSeqDefault(),
        fac.makeColumn("visitingTimeStr", "计划拜访年月", 160),
        fac.makeColumn("deptName", "部门", 160),
        fac.makeColumn("firstWeek", "第1周拜访数量", 160),
        fac.makeColumn("twoWeek", "第2周拜访数量", 160),
        fac.makeColumn("threeWeek", "第3周拜访数量", 160),
        fac.makeColumn("fourthWeek", "第4周拜访数量", 160),
        fac.makeColumn("weeksum", "合计拜访数量", 160),
        fac.makeColumn({
            title: "操作",
            field: 'operate',
            slots: {
                default: 'default'
            },
            align: 'center',
            width: 200,
            fixed:'right'
        }),
    ];

    // 筛选条件
    const formConfig = fac.makeFormConfig(columns, [
        {
            field: "deptId",
            title: "部门",
            type: "select",
            options: [],
        },
        {
            field: 'visitingTime',
            customSearch: true,
            title: "计划拜访年月",
            type: 'month',
        },
    ]);

    //工具栏按钮
    const toolbarConfig = fac.makeToolbarConfig({
        addData: true,
        export: true,
        import: false,
        delData: false,
        templatelSlots: "toolbarBtns",
    });

    //可编辑表格约束
    const editRules = fac.makeEditRules(columns);
    const printConfig = fac.makePrintConfig(columns);
    const pagerConfig = fac.makePagerConfig();
    const checkboxConfig = fac.makeCheckboxConfig(columns);

    async function loadBaseData() {
        // let region = {
        //     isRegion: 1,
        //     isDealer: 0
        // }
        // let dealer = {
        //     isRegion: 0,
        //     isDealer: 1
        // }
        // this.strainOptions = await loadBaseCodeData('CD200007')
        // let strainData = await dataApi.getStrainList();
        // console.log(this.strainOptions);
        // this.wantLevelOptions = await loadBaseCodeData('CD200002')
        // this.regionOptions = await dataApi.selection(region);//经理部
        this.deptOptions = await dataApi.popSelectVisit();//拜访部门List
        // this.dealerOptions = await dataApi.selection(dealer);//经销商
        // this.dealChanceOptions = await loadBaseCodeData('CD200008')//成交概率
        // this.clueSourceOptions = await loadBaseCodeData('CD200004')//线索来源
        console.log(this.deptOptions);
        // let commCodeData = await dataApi.getCommCode();
        // let DeptUsers = await dataApi.getDeptUsers();
        // if(DeptUsers.code!==200){
        //
        // }
        // 经理部下拉处理
        this.deptOptions = this.deptOptions.data.map(v => {
            return {
                label: v.deptName,
                value: v.deptId
            }
        });
        this.loadSearchOption({
            deptId: this.deptOptions,
        })
        // // 经理部下拉处理
        // this.regionOptions = this.regionOptions.data.map(v => {
        //     return {
        //         label: v.deptName,
        //         value: v.deptId
        //     }
        // });
        // this.regionOptions = [{
        //     value: '',
        //     label: '全部'
        // }].concat(this.regionOptions);
        // this.loadSearchOption({
        //     deptId: this.regionOptions,
        // })
//     // 经销商下拉处理
//     this.dealerOptions = this.dealerOptions.data.map(v => {
//         return {
//             label: v.deptName,
//             value: v.deptName
//         }
//     })
//     this.dealerOptions = [{
//         value: '',
//         label: '全部'
//     }].concat(this.dealerOptions);
//     this.loadSearchOption({
//         dealerName: this.dealerOptions,
//     })
//
//     this.strainOptions = strainData.data.map(v => {
//         return {
//             label: v.strainName,
//             value: v.strainId,
//         }
//     })
//     this.strainOptions = [{
//         value: '',
//         label: '全部'
//     }].concat(this.strainOptions);
//     this.loadSearchOption({
//         strainId: this.strainOptions,
//     })
//
//     this.wantLevelOptions = this.wantLevelOptions.map(v => {
//         return {
//             label: v.label,
//             value: v.value
//         }
//     })
//     this.wantLevelOptions = [{
//         value: '',
//         label: '全部'
//     }].concat(this.wantLevelOptions);
//     this.loadSearchOption({
//         wantLevel: this.wantLevelOptions,
//     })
//     //成交概率
//     this.dealChanceOptions = this.dealChanceOptions.map(v => {
//         return {
//             label: v.label,
//             value: v.value
//         }
//     })
//     this.dealChanceOptions = [{
//         value: '',
//         label: '全部'
//     }].concat(this.dealChanceOptions);
//     this.loadSearchOption({
//         dealChance: this.dealChanceOptions,
//     })
//
// ////线索来源
//     this.clueSourceOptions = this.clueSourceOptions.map(v => {
//         return {
//             label: v.label,
//             value: v.value
//         }
//     })
//     this.clueSourceOptions = [{
//         value: '',
//         label: '全部'
//     }].concat(this.clueSourceOptions);
//     this.loadSearchOption({
//         clueSourceId: this.clueSourceOptions,
//     })
    }

    export default {
        mixins: [GridMixin],
        // authorize: {
        //   addRow: "ADD",
        //   updateRow: 'UPDATE',
        //   // delRow: 'DELETE',
        //   // importMethod:'IMPORT',
        //   // exportMethod:'EXPORT',
        // },
        components: {
            detailForm
        },
        computed: {
            ...mapState("account", {currUser: "user"}),
        },
        watch: {
            $route: {
            },
        },
        data() {
            return {
                // popConfig,
                columns,
                rowId,
                url,
                formConfig,
                toolbarConfig,
                printConfig,
                checkboxConfig,
                editRules,
                pagerConfig,
                exportConfig:{
                    remote: true,
                    types: ['xlsx'],
                    modes: ['all']
                },
                userIdList: [],
                strainOptions: [],
                wantLevelOptions: [],
                startDate: this.$store.state.setting.startTime || null,
                endDate: this.$store.state.setting.endTime || null,
                isTodayFollow: this.$store.state.setting.isTodayFollow || null,
                isNotFollow: this.$route.query.isNotFollow,
                fromIndexParam: this.$route.query.fromIndexParam,
                visitingTime: this.$route.query.visitingTime,
                // deptId: this.$route.query.deptId,
                //  新增的
                // regionId: '', dealerId: '',
                deptId: '',
                //角色树
                autoExpandParent: false,
                defaultExpandedKeys: [],
                selectedKeys: [],
                expandedKeys: [],
                checkedKeys: [],
                deptList: [],
                treeData: [],
                selectedUser: [],
                treeSpin: false,
                showLeft: false,
                type: 'dept',
                //  新增的结束
                formData:null,//筛选项数据
                fileList: [],
                uploadDialog: false,
                importLoading: false,
                errorList: [],
                token: localStorage.getItem('token'),
            };
        },
        mounted() {
            //  新增的
            this.init();
            //  新增的结束
            this.formData = this.$refs.grid.$refs.xGrid.formData; //获取筛选项
        },
        methods: {
            ...mapMutations('setting', ['setStartTime', 'setEndTime', 'setIsTodayFollow']),
            loadBaseData,
            closeDetailPop() {
                this.editModalVisible = false;
            },
            merchants() {

                let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
                console.log(rows)

                this.userIdList = rows.map((i) => {
                    return i.userId;
                }).join(',')
                console.log(this.userIdList)
                this.chooseOpenPop('merchantsAuthorization', 1)
            },
            closeLog() {
                this.logModalVisible = false;
            },
            //  新增的
            init() {
                // dataApi.popSelect().then(res => {
                // dataApi.popSelectVisit().then(res => {
                //     this.treeData = XEUtils.toArrayTree(res.data, {
                //         parentKey: 'parentId',
                //         key: 'deptId',
                //         children: 'children'
                //     })
                // })
            },
            handleChange() {
                this.closeAll()
                this.init()
            },
            closeAll() {
                this.checkedKeys = []
                //this.followUserId = ''
                this.regionId = ''
                this.dealerId = ''
                this.deptId = ''
                // XEUtils.mapTree(this.treeData, item => {
                //     if (item.userList) {
                //         item.userList.map(user => {
                //             user.checked = false
                //         })
                //     }
                //     return item
                // })
                this.selectedUser = []
                this.$nextTick(() => {
                    this.refresh()
                })
            },
            onExpand(expandedKeys) {
                this.expandedKeys = expandedKeys;
                this.autoExpandParent = false;
            },
            onCheck(checkedKeys) {
                this.checkedKeys = checkedKeys;
            },

            onSelect(selectedKeys, {checkedNodes}) {
                this.selectedKeys = selectedKeys
                let regionId = [], dealerId = [], deptId = []//三个数组
                checkedNodes.forEach(item => {//对象里的每一个
                    if (item.data.props.isDealer === 1) {
                        dealerId.push(item.key)
                    } else if (item.data.props.isRegion === 1) {
                        regionId.push(item.key)
                    } else {
                        deptId.push(item.key)
                    }
                })
                this.regionId = regionId.toString()
                this.dealerId = dealerId.toString()
                this.deptId = deptId.toString()
                this.$nextTick(() => {
                    this.refresh()
                })
            },
            //  新增的结束
            /**
             * 经理部 经销商联动数据
             * @param id
             * @return {Promise<void>}
             */
            // async getDealerData(id) {
            //     let dealer = {
            //         isRegion: 0,
            //         isDealer: 1,
            //         'filter.eq.parentId': id,
            //     }
            //     this.dealerOptions = await dataApi.selection(dealer);//经销商
            //     // 经销商下拉处理
            //     this.dealerOptions = this.dealerOptions.data.map(v => {
            //         return {
            //             label: v.deptName,
            //             value: v.deptName
            //         }
            //     })
            //     this.dealerOptions = [{
            //         value: '',
            //         label: '全部'
            //     }].concat(this.dealerOptions);
            //     this.loadSearchOption({
            //         dealerName: this.dealerOptions,
            //     })
            // },
            // 删除活动类型
            async deleteGroup(row) {
                // console.log('row=====================================================')
                // console.log(row);
                let vm = this;
                // console.log('vm========================================================')
                // console.log(vm);
                vm.$confirm({
                    title: '确认删除？',
                    async onOk() {
                        let entity = await dataApi.deleteItem(row.id); //删除
                        if (entity.code === 200) {
                            vm.$message.success('删除成功');
                            location.reload();
                            vm.refresh();
                        } else {
                            vm.$message.warn(entity.data);
                        }

                    }
                })
            },
            download() {
                axios.get('visitPlanExample.xlsx', {   //静态资源文件夹public
                    responseType: 'blob',
                }).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    let fname = '拜访计划导入模板.xlsx';
                    link.href = url;
                    link.setAttribute('download', fname);
                    document.body.appendChild(link);
                    link.click();
                }).catch(error => {
                    console.log('error:' + JSON.stringify(error))
                });
            },
            /**
             * 上传
             */
            handleFileChange({file}) {
                console.log(file)
                if (file.status === 'done') {
                    if (file.response.code == 500) {
                        this.bus.$emit('loading', false);
                        console.log('error', file)
                        this.$message.error('导入数据不规范,示范文件下载中...')
                        let downFile = api.visit.ERROREXCEL + 'error/' + file.response.msg + "?download=1";
                        axios.get(downFile, {responseType: "blob"})
                            .then((res) => {
                                const blob = new Blob([res.data], {
                                    type: "application/vnd.ms-excel;charset=utf-8",
                                });
                                const href = window.URL.createObjectURL(blob);
                                const downloadElement = document.createElement("a");
                                downloadElement.href = href;
                                var name = res.headers["content-disposition"];
                                downloadElement.download = decodeURI(name.substring(name.lastIndexOf("=") + 1));
                                document.body.appendChild(downloadElement);
                                downloadElement.click();
                                document.body.removeChild(downloadElement);
                                window.URL.revokeObjectURL(href);
                            }).catch((fail) => {
                            console.error(fail);
                        });
                    } else {
                        console.log('success', file)
                        this.bus.$emit('loading', false);
                        this.$message.success('导入成功')
                    }
                }
            },
        },
    };
</script>

<style scoped lang="less">
    //新增的开始
    /deep/ .ant-radio-group {
        display: flex;
        width: 100%;

        .ant-radio-wrapper {
            flex: 1;
        }

        .item {
            margin: 16px 0;
        }
    }

    .left_tree {
        width: 260px;
        float: left;
        padding: 20px;
        height: calc(100vh - 48px - 64px);
        border-right: 1px solid #e0e0e0;
        background: #fff;
        overflow-y: scroll;
        overflow-x: hidden;
        position: relative;
    }

    .right_table {
        width: calc(100% - 260px);
        float: right;
        height: 100%;
        position: relative;

        .close {
            position: absolute;
            top: 50%;
            left: -18px;
            display: block;
            z-index: 1000;
            font-size: 36px;
            cursor: pointer;
            color: #fff;
            background-color: #bbb;
            border-radius: 18px;
        }
    }

    .showLeft {
        width: 100%;
    }

    //新增的结束
</style>
